import React, { PropsWithChildren, useRef } from 'react'
import {
  TtIcon,
  TtDropdown,
  TtButton,
  TtMenu,
  TtMenuLabel,
  TtMenuDivider,
  TtMenuItem,
} from '@23/react'
import { intl } from 'lang/intl'
import classNames from 'classnames'
import { useParticipantIdSelectedInMixedMode } from '../../../../firebase/hooks/useMixedMode'
import { useHumanParticipants } from '../../../../webrtc/webRTCRoom'

import './MixedModeParticipantListPopOver.scss'

export interface MixedModeParticipantListPopoverProps {
  onConfirmClick?: (selectedValue: number | null) => void
}

const MixedModeParticipantListPopOver = ({
  onConfirmClick = () => {},
}: PropsWithChildren<MixedModeParticipantListPopoverProps>) => {
  const dropdownRef = useRef<HTMLTtDropdownElement>(null)
  const participants = useHumanParticipants()
  const selectedParticipantId = useParticipantIdSelectedInMixedMode()

  const ariaLabel = intl.formatMessage({
    defaultMessage: 'Select Mixed Mode speaker',
  })

  const hasASpeakerSelected = participants.some(
    (p) => p.id === selectedParticipantId
  )

  return (
    <TtDropdown
      ref={dropdownRef}
      className="mixed-mode-participant-list-popover"
      placement="bottom-start"
      distance={8}
      skidding={40}
      hoist
    >
      <TtButton
        slot="trigger"
        color="secondary"
        className="mixed-mode-participant-selector-button"
        aria-label={ariaLabel}
        size="small"
      >
        <TtIcon
          name="settings"
          library="one"
          className={classNames('mixed-mode-participant-selector-icon', {
            highlighted: !hasASpeakerSelected,
          })}
        />
      </TtButton>
      <TtMenu mode="radio" className="mixed-mode-radio-menu">
        <TtMenuLabel>
          {intl.formatMessage({
            defaultMessage: 'Select Speaker',
          })}
        </TtMenuLabel>
        <TtMenuDivider />
        {participants.map((p) => (
          <TtMenuItem
            key={p.id}
            value={`${p.id}`}
            checked={p.id === selectedParticipantId}
            onTt-click={(e) => onConfirmClick(+e.detail.value)}
          >
            {p.name}
          </TtMenuItem>
        ))}
      </TtMenu>
    </TtDropdown>
  )
}

export { MixedModeParticipantListPopOver }
